<template>
    <v-panel
        v-model="currentOpen"
        :mask-closable="false"
        :title="title"
        class="select-hot-panel-model"
        @close="handleCancel"
    >
        <div
            v-on-scrollto.bottom.10="handleScroll"
            v-spinner:refreshLoading="refreshLoading"
            class="select-hot-panel-model-bd"
        >
            <div :class="['operation', { empty: emptyData }]">
                <v-tip ref="refresh" placement="top">刷新</v-tip>
                <a v-tip:refresh.hover class="refresh-icon" href="javascript:;" @click="refreshTplList">
                    <v-icon name="refresh"></v-icon>
                </a>
                <a v-if="permission" class="create-link" href="/tp/IMAccessSet/sidebarEdit" target="_blank">新建模板</a>
                <h5 v-if="emptyData">暂无模板</h5>
            </div>
            <div class="template-container">
                <template v-for="(tplCol, idx) in [templateListCol0, templateListCol1, templateListCol2]">
                    <div :key="idx" class="item-container">
                        <div
                            v-for="template in tplCol"
                            :key="template.id"
                            :class="['item', { selected: template.id === innerSelectedId }]"
                            @click="handleSelect(template)"
                        >
                            <h3 class="template-name">{{ template.name }}</h3>
                            <div class="mask">
                                <v-checkbox
                                    v-if="template.id === innerSelectedId"
                                    :disabled="false"
                                    :checked="true"
                                    class="panel-checkbox"
                                />
                                <webim-hot-panel :content="template.content" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div v-spinner:moreLoading="moreLoading" v-if="!emptyData" class="more-loading">
                <v-spinner id="moreLoading" size="large"></v-spinner>
            </div>
            <v-spinner id="refreshLoading" :opacity="1" size="large"></v-spinner>
        </div>
        <div class="select-hot-panel-model-ft">
            <v-button
                :disabled="invalidSelect"
                class="select-hot-panel-model-ft-confirm"
                kind="primary"
                size="large"
                @click="handleConfirm"
                >确定</v-button
            >
            <v-button class="select-hot-panel-model-ft-cancel" size="large" @click="handleCancel">取消</v-button>
        </div>
    </v-panel>
</template>

<script>
import WebimHotPanel from 'src/components/webim-hot-panel';

export default {
    name: 'SelectHotPanelModel',
    components: {
        WebimHotPanel
    },
    model: {
        prop: 'open',
        event: 'input'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '选择自定义模板'
        },
        // 自定义模板权限位
        permission: {
            type: Number,
            default: 0
        },
        selectedId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            currentOpen: false,
            page: 1,
            count: 10,
            total: 0,
            moreLoading: false,
            refreshLoading: false,
            templateListCol0: [],
            templateListCol1: [],
            templateListCol2: [],
            existIdMap: {},
            // 打开弹窗后临时选中项
            tempSelectTpl: null
        };
    },
    computed: {
        invalidSelect() {
            return false;
        },
        hasFetch() {
            return this.page > 1;
        },
        emptyData() {
            // 列表为空数据
            return this.noneData && this.total === 0;
        },
        noneData() {
            // 还没有拉过数据的话，不能判断没有数据了，因此返回false
            if (!this.hasFetch) {
                return false;
            }

            // 当前拉取数量 >= 总数，那么就没有数据了
            const curFetchCount = (this.page - 1) * this.count;
            return curFetchCount >= this.total;
        },
        listColHeight0() {
            return this.templateListCol0.reduce((height, t) => height + t.height, 0);
        },
        listColHeight1() {
            return this.templateListCol1.reduce((height, t) => height + t.height, 0);
        },
        listColHeight2() {
            return this.templateListCol2.reduce((height, t) => height + t.height, 0);
        },
        innerSelectedId() {
            if (this.tempSelectTpl) {
                return this.tempSelectTpl.id;
            }

            return this.selectedId;
        }
    },
    watch: {
        open(nextValue) {
            this.currentOpen = nextValue;
        },
        currentOpen(nextValue) {
            this.$emit('input', nextValue);
        }
    },
    mounted() {
        this.updateTemplateList();
    },
    methods: {
        fetchTemplateList(index = 1, count = 10) {
            const pageListURL = '/receptionConf/sidebar/template/pageList';
            const params = { index, count };
            const success = res => {
                if (res.code !== 0) {
                    throw new Error(res.message);
                }

                return res.data;
            };
            const failed = err => this.$message.error(err.message);

            return this.$ajax
                .gatewayGet(pageListURL, { params })
                .then(success)
                .catch(failed);
        },
        handleScroll() {
            if (this.noneData) {
                return;
            }

            if (this.moreLoading || this.refreshLoading) {
                return;
            }

            this.loadMoreTplList();
        },
        updateTemplateList() {
            const { page, count } = this;

            // eslint-disable-next-line no-shadow
            return this.fetchTemplateList(page, count).then(({ total, records }) => {
                this.total = Number(total);
                this.page = page + 1;

                // 去重
                const removeDuplicateRecords = this.removeDuplicateTpl(records);
                // 将content解析成对象数组
                const templateRecords = this.parseContentTpl(removeDuplicateRecords);
                // 粗略计算一下每个模板渲染出来的高度
                const rectTplRecords = this.computeRectHeightTpl(templateRecords);
                this.dispatchTemplatesToCol(rectTplRecords);
            });
        },
        loadMoreTplList() {
            this.moreLoading = true;

            this.updateTemplateList().finally(() => {
                this.moreLoading = false;
            });
        },
        refreshTplList() {
            this.resetListParams();
            this.refreshLoading = true;

            this.updateTemplateList().finally(() => {
                this.refreshLoading = false;
            });
        },
        resetListParams() {
            this.page = 1;
            this.total = 0;
            this.templateListCol0 = [];
            this.templateListCol1 = [];
            this.templateListCol2 = [];
            this.existIdMap = {};
        },
        dispatchTemplatesToCol(list) {
            // eslint-disable-next-line consistent-return
            list.forEach(t => {
                const curTplHeight = t.height;

                const plan0 = [this.listColHeight0 + curTplHeight, this.listColHeight1, this.listColHeight2];
                const diff0 = Math.max.apply(null, plan0) - Math.min.apply(null, plan0);

                const plan1 = [this.listColHeight0, this.listColHeight1 + curTplHeight, this.listColHeight2];
                const diff1 = Math.max.apply(null, plan1) - Math.min.apply(null, plan1);

                const plan2 = [this.listColHeight0, this.listColHeight1, this.listColHeight2 + curTplHeight];
                const diff2 = Math.max.apply(null, plan2) - Math.min.apply(null, plan2);

                const minHeightDiff = Math.min(diff0, diff1, diff2);
                if (diff0 === minHeightDiff) {
                    return this.templateListCol0.push(t);
                }
                if (diff1 === minHeightDiff) {
                    return this.templateListCol1.push(t);
                }
                if (diff2 === minHeightDiff) {
                    return this.templateListCol2.push(t);
                }
            });
        },
        removeDuplicateTpl(list) {
            return list.filter(({ id }) => {
                if (this.existIdMap[id]) {
                    return false;
                }

                this.existIdMap[id] = true;
                return true;
            });
        },
        parseContentTpl(list) {
            // 将content解析成对象数组
            return list.map(tpl => {
                let { content } = tpl;
                if (typeof content === 'string') {
                    try {
                        content = JSON.parse(content);
                    } catch (e) {
                        content = [];
                        this.$message.error(`解析自定义侧边栏模板出错: ${e.message}`);
                    }
                }

                tpl.content = content;
                return tpl;
            });
        },
        computeRectHeightTpl(list) {
            return list.map(tpl => {
                let height = 0;

                const textItemComputer = item => {
                    // 标题高度
                    if (item.title) {
                        height += 18;
                    }

                    const itemLen = item.list.length;
                    // 文本高度 + 上边距
                    height += 18 * itemLen + 8 * itemLen;
                };

                const cardItemComputer = item => {
                    // 标题高度
                    if (item.title) {
                        height += 18;
                    }

                    const itemLen = item.list.length;
                    const row = Math.ceil(itemLen / 3);
                    // 卡片一行高度 + 上边距
                    height += 64 * row + 8 * row;
                };

                const imgItemComputer = item => {
                    // 标题高度
                    if (item.title) {
                        height += 18;
                    }

                    const itemLen = item.list.length;
                    const row = itemLen && 1;
                    // 文本高度 + 上边距
                    height += 126 * row + 8 * row;
                };

                const { content } = tpl;
                // eslint-disable-next-line consistent-return
                content.forEach(item => {
                    if (item.type === 'text') {
                        return textItemComputer(item);
                    }

                    if (item.type === 'card') {
                        return cardItemComputer(item);
                    }

                    if (item.type === 'img') {
                        return imgItemComputer(item);
                    }
                });

                // 整个template上外边距 + template标题加下边距 + template内边距高度
                height += 32 + 32 + 40;
                tpl.height = height;
                return tpl;
            });
        },
        resetTempSelectTpl() {
            this.tempSelectTpl = null;
        },
        handleSelect(template) {
            this.tempSelectTpl = template;
        },
        handleConfirm() {
            this.emitSelectEvent(this.tempSelectTpl);
            this.handleCancel();
        },
        handleCancel() {
            this.resetTempSelectTpl();
            this.currentOpen = false;
        },
        emitSelectEvent(tpl) {
            this.$emit('select', tpl);
        }
    }
};
</script>

<style lang="less">
@import '~@/styles/variables.less';

.select-hot-panel-model {
    font-family: PingFang SC, Microsoft Yahei, serif;

    .alert-message {
        margin-top: -20px;
        margin-bottom: 11px;
        color: #a1abc2;
    }

    &-radio {
        height: 30px;

        .v-radio-group {
            position: relative;
            top: -5px;

            &--default {
                .v-radio-group-item {
                    margin: 0 30px;
                }
            }
        }
    }

    &-tip {
        position: absolute;
        top: 55px;
        width: 100%;
        font-size: 12px;
        text-align: center;
        color: #a8abb3;
    }

    &-bd {
        height: 548px;
        background: #f5f7fa;
        overflow-y: auto;

        &::-webkit-scrollbar-track-piece {
            background: #f5f7fa !important;
        }

        .operation {
            width: 100%;
            height: 32px;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;

            .create-link {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                color: @mainBlack;
                margin-right: 14px;

                &:hover {
                    color: @mainBlue;
                }
            }

            .refresh-icon {
                display: flex;
                color: @mainLightGray;
                margin-right: 20px;

                &:hover {
                    color: @mainDeepGray;
                }
            }

            &.empty {
                height: 100%;
                flex-direction: column-reverse;
                justify-content: center;

                .create-link {
                    margin-right: 0;
                    margin-top: 10px;
                    color: @mainBlue;
                }

                .refresh-icon {
                    margin-right: 0;
                    margin-top: 20px;
                }

                h5 {
                    font-size: 20px;
                    line-height: 1;
                }
            }
        }

        .template-container {
            display: flex;
            flex-direction: row;

            .item-container {
                flex-direction: column;
                width: 240px;
                margin: 0 24px;

                &:first-child {
                    margin-left: 40px;
                    margin-right: 0;
                }

                &:last-child {
                    margin-rhgit: 40px;
                    margin-left: 0;
                }

                .item {
                    margin-top: 32px;

                    .mask {
                        position: relative;
                        border-radius: 6px;
                    }

                    h3.template-name {
                        text-align: left;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 20px;
                        color: #1e2330;
                        margin-bottom: 12px;
                    }

                    &:first-child {
                        margin-top: 0;
                    }

                    &:hover {
                        h3.template-name {
                            color: #0067ed;
                        }

                        .mask {
                            cursor: pointer;
                            outline: 2px solid #0067ed;

                            .webim-hot-panel {
                                opacity: 0.5;
                            }
                        }
                    }

                    &.selected {
                        h3.template-name {
                            color: #0067ed;
                        }

                        .mask {
                            outline: 2px solid #0067ed;

                            .panel-checkbox {
                                position: absolute;
                                z-index: 1;
                                width: 18px;
                                height: 18px;
                                top: 10px;
                                right: 10px;

                                .v-checkbox__icon {
                                    margin: 0;
                                }
                            }

                            .webim-hot-panel {
                                opacity: 0.5;
                            }
                        }
                    }

                    .webim-hot-panel .hot-panel-multi-content {
                        text-align: initial;
                    }
                }
            }
        }

        .more-loading {
            padding: 30px 0;

            .v-spinner__before {
                background-color: transparent !important;
            }
        }
    }

    &-ft {
        height: 60px;
        padding-top: 20px;
        box-shadow: 0 1px 15px rgba(30, 36, 49, 0.15);

        &-confirm,
        &-cancel {
            margin: 0 10px;
        }
    }

    .v-panel__content {
        border-radius: 4px;
        width: 848px !important;
        height: 680px;
    }
}
</style>
